
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DatabaseServerPropertiesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"os"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWindows"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"databaseServer"},"name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DatabaseServer"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"host"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"port"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serverVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDefaultServer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUsedForPsaDb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdminCredentialsChangeable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminLogin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"externalConnections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"databasesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backupSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempDir"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkTempDir"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkPassword"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":634}};
    doc.loc.source = {"body":"query DatabaseServerPropertiesPage($id: ID!) {\r\n    os {\r\n        isWindows\r\n    }\r\n    databaseServer: node(id: $id) {\r\n        id\r\n        ... on DatabaseServer {\r\n            name\r\n            type\r\n            host\r\n            port\r\n            serverVersion\r\n            isDefaultServer\r\n            isUsedForPsaDb\r\n            isAdminCredentialsChangeable\r\n            adminLogin\r\n            externalConnections\r\n            databasesCount\r\n            backupSettings {\r\n                tempDir\r\n                networkTempDir\r\n                networkUser\r\n                networkPassword\r\n            }\r\n        }\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DatabaseServerPropertiesPage"] = oneQuery(doc, "DatabaseServerPropertiesPage");
        
